export default __webpack_public_path__ + "static/media/bahriakarachi.1b5cf794.jpg";